import { render, staticRenderFns } from "./DataForwarding.vue?vue&type=template&id=5e14f32e"
import script from "./DataForwarding.vue?vue&type=script&lang=js"
export * from "./DataForwarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports